"use client";import e,{createContext as t}from"react";import"clsx";const o=t(null),s=()=>e.useContext(o);export{o as ThemeContext,s as useTheme};
